/**
 *
 *  로그인 페이지의 레이아웃을 담당한다.
 */

import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box, Container } from '@mui/material';

const theme = createTheme();

const LoginTemplate = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              paddingBottom: theme.spacing(1),
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              //borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <img src="/static/images/logo/logo.svg" alt="logo" />
          </Box>
          {children}
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default LoginTemplate;
